import React, { Fragment } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import { ReusableOnboardingButton } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import isEmpty from "../../../../store/validation/is-Empty";
import Validator from "validator";
import Media from "react-media";

const RestaurantChainWrapperComponent = ({ localProps, state, ...props }) => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>

          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/profile"
              displayText="Back"
            />
            <div className="col-12 col-md-6">
              {/* onboarding_process_screen_left */}
              <div className="onboarding_process_screen-left-mapinside p-0">
                <div>
                  <TopTextReusableComponent
                    headingText={
                      state.is_suggest_new_open === true
                        ? "Business Chain Details"
                        : "Business Settings"
                    }
                    headingParagraph={
                      state.is_suggest_new_open === true
                        ? "Please enter details about your restaurant Chain"
                        : "Enter the Details about the Locale of your restaurant"
                    }
                    // displayEdit={state.editButton}
                    // onClickEdit={localProps.editClick}
                  />
                </div>

                {props.children}
                <div className="col-12 p-0 mt-5 d-flex justify-content-between mb-4">
                  {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                  <ReusableOnboardingButton
                    buttonTitle="Cancel Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Cancel"
                    onClick={
                      state.are_you_part_of_chain === false
                        ? () => props.history.push("/seatingdashboard")
                        : state.is_suggest_new_open === true
                        ? localProps.onBackButtonSuggestNew
                        : localProps.onBackButtonChainPage
                    }
                  />
                  {/* {state.editButton === true ? ( */}
                  <ReusableOnboardingButton
                    buttonTitle="Save Button"
                    buttonText="Save"
                    buttonType="button"
                    disabled={
                      errorHandler(state)
                      // || state.actionButton === false
                    }
                    onClick={
                      // state.actionButton === false
                      //   ? localProps.onWithOutApiCall
                      //   :
                      state.are_you_part_of_chain === false
                        ? () => props.history.push("/seatingdashboard")
                        : state.is_suggest_new_open === true
                        ? localProps.onSuggestNewSubmitHandler
                        : localProps.onhandleSubmit
                    }
                    buttonClass={`onboarding_button_link_reusable ${
                      errorHandler(state)
                        ? // || state.actionButton === false
                          "onboarding_button_link_reusable_gray"
                        : "onboarding_button_link_reusable_red"
                    }`}
                  />
                  {/* ) : null} */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>

          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
    </Fragment>
  );
};

export default RestaurantChainWrapperComponent;

const errorHandler = (state) => {
  if (state.are_you_part_of_chain === false) {
    return false;
  } else if (state.is_suggest_new_open === true && isEmpty(state.errors)) {
    if (
      state.title === "" ||
      state.address === "" ||
      state.area === "" ||
      state.city === "" ||
      state.phone_numbers[state.phone_numbers.length - 1].mobile_no === "" ||
      state.phone_numbers[state.phone_numbers.length - 1].mobile_no.length <
        10 ||
      state.enquiry_emails[state.enquiry_emails.length - 1] === "" ||
      !Validator.isEmail(
        state.enquiry_emails[state.enquiry_emails.length - 1]
      ) ||
      state.icon.length <= 0
    ) {
      return true;
    } else {
      return false;
    }
  } else if (state.restaurant_chain_id !== "") {
    return false;
  } else {
    return true;
  }
};
